import { jsx as L } from "react/jsx-runtime";
import { runQuery as P } from "../db/query.js";
import { duckDB as w } from "../duckDB.js";
import { useDuckDB as T } from "../hooks/useDuckDB.js";
import { useDuckDBConnectionContext as B } from "../providers/connectionProvider.js";
import { ResolvableStatus as y } from "../utils/resolvable.js";
import { useQuery as v } from "@tanstack/react-query";
import { createContext as O, useContext as g } from "react";
const I = {
  staleTime: 1 / 0
}, h = async (s, n) => {
  const u = await Promise.all(
    s.map((e) => w.initializeFromUrl(e))
  );
  if (u.some((e) => e.error))
    throw new Error(u.find((e) => e.error)?.error);
  return n.onSuccess && await n.onSuccess(P), {
    success: !0
  };
}, R = ({
  queryClient: s,
  options: n
}) => {
  const u = {
    ...I,
    ...n
  }, e = (r, t) => {
    const c = Array.isArray(r) ? r : [r], C = c.every((o) => !!o.url), { enabled: d, queryKey: b, throwOnError: k } = t, { status: a } = T(), { get: E } = B(), m = c.every(
      (o) => !E(o.databaseName)
    ), { data: l, isLoading: p } = v(
      {
        queryKey: [b],
        queryFn: () => h(c, t),
        enabled: (d || d === void 0) && C && a === y.COMPLETED && m,
        staleTime: 1 / 0,
        gcTime: 1 / 0,
        throwOnError: k
      },
      s
    );
    function D({
      enabled: o = !0,
      ...x
    }) {
      const f = !!l?.success && a === y.COMPLETED && o && !m, Q = v(
        {
          ...x,
          ...u,
          enabled: o && f
        },
        s
      );
      return {
        ...Q,
        isLoading: p || (f ? Q?.isLoading : !0)
      };
    }
    return !l || m || a !== y.COMPLETED ? {
      isLoading: !0,
      success: !1,
      error: void 0,
      useQueryHook: D
    } : {
      isLoading: !1,
      success: !0,
      error: void 0,
      useQueryHook: D
    };
  }, i = O((() => {
  }));
  return {
    useDBConnection: e,
    Context: i,
    Provider: ({
      useQueryHook: r,
      children: t
    }) => /* @__PURE__ */ L(i.Provider, { value: r, children: t }),
    useQuery: (r) => {
      const t = g(i);
      if (!t)
        throw new Error(
          "useDuckDBQuery Context must be used within a QueryContext Provider"
        );
      return t(r);
    }
  };
};
export {
  R as makeDuckDbQueryContext
};
